import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  CircularProgress,
  Box,
  Typography,
  TableContainer,
  Paper,
} from "@mui/material";
import moment from "moment";
import { allApis } from "../../request/config";
import apiRequest from "../../request/apiRequest/apiRequest";
import ReportedDetails from "./ReportedDetails";

interface Report {
  reported_by: any;
  reported_message: string;
  reported_at: string;
}

interface ReportDialogProps {
  report: any;
  onClose: () => void;
}

const ReportDialog: React.FC<ReportDialogProps> = ({ report, onClose }) => {
  const [{ list, load }, setData] = useState<{ load: boolean; list: Report[] }>(
    { load: true, list: [] }
  );
  const fetchReportData = async (reportId: string) => {
    try {
      const response: any = await apiRequest({
        api: allApis.getReportDetails(reportId),
        method: "GET",
      });
      setData({ list: response, load: false });
    } catch (error: any) {
      throw new Error(error.message);
    }
  };
  useEffect(() => {
    fetchReportData(report.id);
  }, []);
  return (
    <Dialog
      sx={{
        "& .MuiDialog-container": {
          backdropFilter: "blur(3px)", // subtle blur
        },
      }}
      open={true}
      onClose={onClose}
      maxWidth="md"
      fullWidth
    >
      {report && (
        <Box sx={{ m: "16px", width: "calc(100% - 32px)" }}>
          <ReportedDetails
            heading="Users details of"
            row={report}
            reportid={report.id ?? ""}
          />
        </Box>
      )}

      <DialogContent
        dividers
        sx={{
          // height: "calc(100dvh - 123px)",
          maxHeight: "calc(100dvh - 180.5px)",
          minHeight: "300px",
          boxSizing: "border-box",
          overflow: "hidden",
        }}
      >
        {load ? (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="200px"
          >
            <CircularProgress />
          </Box>
        ) : list.length === 0 ? (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="200px"
          >
            <Typography color="textSecondary">
              No report details available
            </Typography>
          </Box>
        ) : (
          <TableContainer
            sx={{
              height: "100%",
              width: "100%",
              overflowY: "auto",
              maxHeight: "calc(100dvh - 212.5px)",
            }}
            component={Paper}
            className="scrollBluePrimarythin"
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ padding: "16px" }}>
                    <b>#id</b>
                  </TableCell>
                  <TableCell sx={{ padding: "16px" }}>
                    <b>Name</b>
                  </TableCell>
                  <TableCell sx={{ padding: "16px" }}>
                    <b>Phone</b>
                  </TableCell>
                  <TableCell sx={{ padding: "16px" }}>
                    <b>Message</b>
                  </TableCell>
                  <TableCell sx={{ padding: "16px" }}>
                    <b>Reported On</b>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {list.map((report, index) => (
                  <TableRow key={index} hover>
                    <TableCell sx={{ padding: "16px" }}>
                      {report.reported_by ? `#${report.reported_by.id}` : ""}
                    </TableCell>
                    <TableCell sx={{ padding: "16px" }}>
                      {report.reported_by
                        ? `${report.reported_by.full_name}`
                        : ""}
                    </TableCell>
                    <TableCell sx={{ padding: "16px" }}>
                      {report.reported_by ? `${report.reported_by.phone}` : ""}
                    </TableCell>
                    <TableCell sx={{ padding: "16px" }}>
                      {report.reported_message}
                    </TableCell>
                    <TableCell sx={{ padding: "16px" }}>
                      {moment(report.reported_at).format(
                        "Do MMM YYYY, hh:mm A"
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>

      <DialogActions>
        <Button
          onClick={onClose}
          variant="outlined"
          color="primary"
          sx={{ textTransform: "capitalize" }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReportDialog;
